@if (show && contacts.length > 0) {
  <div
    #dropdownContainer
    class="absolute top-full w-full bg-white rounded-lg shadow-lg border border-gray-200 max-h-60 overflow-y-auto z-50"
  >
    @for (contact of contacts; track contact.id) {
      <div
        class="hover:bg-gray-50 px-4 py-2 cursor-pointer flex items-center gap-3 min-w-0"
        (click)="onSelect(contact)"
      >
        <app-user-profile-picture
          [imageUrl]="getImageUrl(contact)"
          [name]="contact.publicName || contact.name"
          [size]="'md'"
          [className]="'size-8 rounded-full'"
        ></app-user-profile-picture>
        <div class="flex-1 min-w-0">
          <div class="text-sm font-medium truncate text-left">{{ contact.publicName || contact.name }}</div>
          <div class="text-xs text-gray-500 truncate text-left">{{ contact.email || contact.nick }}</div>
        </div>
      </div>
    }
  </div>
}
